import {Component, Input} from "@angular/core";
import {AbstractControl, UntypedFormControl, Validators} from "@angular/forms";

@Component({
    selector: 'app-input-textarea',
    template: `
      <label class="text-xs m-0" [for]="name">{{ label ?? name + "_label" | i18next }}@if(isRequired){*}</label>
      <textarea class="w-full" [id]="name" pInputTextarea [cols]="options?.cols" [rows]="options?.rows" [minLength]="options?.minlength" [maxLength]="options?.maxlength" [formControl]="formControl" [placeholder]="(placeholder | i18next)" [autoFocus]="autoFocus" [tabindex]="tabIndex"></textarea>
      <app-input-error-message [control]="formControl" [name]="name"></app-input-error-message>
  `,
    styleUrls: [],
    standalone: false
})

export class InputTextarea {
  @Input() control: AbstractControl | UntypedFormControl;
  @Input() name: string = '';
  @Input() label?: string;
  @Input() placeholder: string;
  @Input() disabled = false;
  @Input() autoFocus: boolean;
  @Input() tabIndex: number;
  @Input() options?: { cols?: string, rows?: string, minlength?: string, maxlength?: string }

  get formControl() {
    return this.control as UntypedFormControl;
  }

  get isRequired() {
    return this.control.hasValidator(Validators.required);
  }
}